import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8d73c3c8&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=8d73c3c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d73c3c8",
  null
  
)

export default component.exports